'use strict';

function LocationMediaReviewElm(
	$stateParams,
	$state,
	$http,
	$timeout,
	$scope,
	auth,
	pmtUtilService,
	pmtFilterService,
	pmtPlanHatService,
	pmtElmService,
	locationDataService
) {
	const $ctrl = this;

	function prepareUserForPinMeToPage(user) {
		const localAccess = { ...user.localAccess };
		localAccess.roles = localAccess.roles ? [...localAccess.roles.values()] : [];
		localAccess.permissions = localAccess.permissions ? [...localAccess.permissions.values()] : [];
		return {
			...user,
			localAccess: localAccess
		};
	}

	const bindArgs = async () => {
		const argsData = await Promise.all([
			locationDataService.get($stateParams.site, $stateParams.placeId),
			auth.getUser($stateParams.site)
		]);

		const place = argsData[0].data;
		const user = argsData[1];

		$ctrl.args = {
			locationId: $stateParams.placeId,
			siteName: $stateParams.site,
			initialFilter: await pmtFilterService.parseFilter($state.params),
			locale: pmtUtilService.getByPath(['settings', 'locale'], user) || '',
			user: prepareUserForPinMeToPage(user),
			locationEnabled: place.isActive
		};

		$scope.$applyAsync();
	};

	bindArgs();

	function onClose() {
		$timeout(() => {
			$ctrl.locationEdit = null;
		});
	}

	function onUpdate(mediaId, locId) {
		$timeout(function () {
			pmtElmService.sendData(
				'Locations.MediaReview.Main',
				'in_Locations_MediaReview_Main_angularPopupUpdated',
				{
					mediaId: mediaId,
					locationId: locId
				}
			);
		});
	}

	function openEditor(field, loc) {
		$ctrl.locationEdit = {
			field: field,
			location: loc,
			onUpdate: onUpdate,
			onClose: onClose
		};
	}

	$ctrl.subscriptions = [
		{
			id: 'TrackReportOnNetwork',
			f: mediaId => {
				pmtPlanHatService.trackMediaReport(mediaId);
			}
		},
		{
			id: 'TrackDeleteMedia',
			f: mediaId => {
				pmtPlanHatService.trackMediaDelete(mediaId);
			}
		},
		{
			id: 'TrackOpenDetailedView',
			f: mediaId => {
				pmtPlanHatService.trackMediaOpen(mediaId);
			}
		},
		{
			id: 'TrackUploadMediaClicked',
			f: () => {
				pmtPlanHatService.trackUploadMediaClicked();
			}
		},
		{
			id: 'TrackMediaUploaded',
			f: () => {
				pmtPlanHatService.trackMediaUploaded();
			}
		},
		{
			id: 'OpenAngularPopup',
			f: ({ field, locationId }) =>
				$timeout(() => {
					$http.get('api/' + encodeURI($stateParams.site) + '/place/' + locationId).then(place => {
						openEditor(field, place.data);
					});
				})
		}
	];
}

LocationMediaReviewElm.$inject = [
	'$stateParams',
	'$state',
	'$http',
	'$timeout',
	'$scope',
	'auth',
	'pmtUtilService',
	'pmtFilterService',
	'pmtPlanHatService',
	'pmtElmService',
	'pmtLocationDataService'
];

angular.module('pmtPlacesApp.controllers').component('pmtLocationMediaReviewElm', {
	controller: LocationMediaReviewElm,
	templateUrl: 'components/location/pmtLocationMediaReviewElm.html'
});
